import React, { useState, useEffect } from "react";
import { showErrorSnackbar } from "../../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";
import { useDialog } from "../../../../contexts/DialogContext";
import SaveIcon from "@mui/icons-material/Save";

import { Grid, DialogActions, Button, CircularProgress } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";

function DeleteOttPlanModal(props) {
  const { ottPlanId, setValue, planGroupOttPlans } = props;

  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { unSetDialog } = useDialog();

  const methods = useForm();

  const { handleSubmit } = methods;

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      const updatedValues = planGroupOttPlans.filter((r) => r.ottPlanId !== ottPlanId);
      setValue("planGroupOttPlans", updatedValues);
      unSetDialog("delete_ott_plan");
      setIsLoading(false);
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to delete plan"));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <i>Do you want to delete this ?</i>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              endIcon={isLoading ? <CircularProgress size={24} /> : null}
              disabled={isLoading}
            >
              Yes
            </Button>

            <Button variant="text" onClick={() => unSetDialog("delete_ott_plan")} color="primary">
              No
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default DeleteOttPlanModal;
